/**
 * Injects "Nebenkosten sind Pauschale" under Kosten; persists value via ImpowerX (rent plan id).
 * @param {{ rentPlanId: string | null }} ctx
 */
const injectNebenkostenPauschale = (ctx) => {
  const rentPlanId = ctx && ctx.rentPlanId ? String(ctx.rentPlanId) : null
  if (document.querySelector('[data-lux-inject="nebenkosten-pauschale"]')) return

  const kostenSection = document.querySelector(
    '[data-testid="secondary-section-wrapper-Kosten"]'
  )
  if (!kostenSection) return

  const contentBox = kostenSection.querySelector('.ant-collapse-content-box')
  if (!contentBox) return

  const mietartBlock = contentBox.querySelector('.RadioGroupInput')
  if (!mietartBlock || !mietartBlock.parentNode) return

  const token = (() => {
    try {
      return JSON.parse(localStorage.getItem('auth') || 'null')?.token
    } catch (_e) {
      return null
    }
  })()

  const wrap = document.createElement('div')
  wrap.className = 'RadioGroupInput'
  wrap.dataset.luxInject = 'nebenkosten-pauschale'
  if (rentPlanId) wrap.dataset.rentPlanId = rentPlanId

  const row = document.createElement('div')
  row.className = 'ant-row ant-form-item ant-form-item-with-help'
  row.style.rowGap = '0px'
  row.style.margin = '2rem 0'

  const labelCol = document.createElement('div')
  labelCol.className = 'ant-col ant-form-item-label'
  const label = document.createElement('label')
  label.className = ''
  label.setAttribute('title', 'Nebenkosten sind Pauschale')
  label.textContent = 'Nebenkosten sind Pauschale'
  labelCol.appendChild(label)

  const controlCol = document.createElement('div')
  controlCol.className = 'ant-col ant-form-item-control'

  const controlInput = document.createElement('div')
  controlInput.className = 'ant-form-item-control-input'

  const controlInner = document.createElement('div')
  controlInner.className = 'ant-form-item-control-input-content'
  controlInner.dataset.luxNebenkostenBody = '1'

  const showSkeleton = () => {
    controlInner.innerHTML = ''
    const sk = document.createElement('div')
    sk.className = 'ant-skeleton ant-skeleton-element ant-skeleton-active'
    sk.setAttribute('data-testid', 'lux-nebenkosten-pauschale-skeleton')
    sk.style.display = 'flex'
    sk.style.alignItems = 'center'
    sk.style.gap = '12px'
    sk.style.minHeight = '32px'
    for (let i = 0; i < 2; i++) {
      const b = document.createElement('div')
      b.className = 'ant-skeleton-input'
      b.style.width = i === 0 ? '56px' : '48px'
      b.style.height = '22px'
      b.style.borderRadius = '4px'
      sk.appendChild(b)
    }
    controlInner.appendChild(sk)
  }

  const persistValue = async (value) => {
    if (!rentPlanId || !token) return
    try {
      await fetch(
        `${baseApiUrl}/api/impowerX/rent-plans/${encodeURIComponent(rentPlanId)}/nebenkosten-pauschale`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ value }),
        }
      )
    } catch (_e) {
      /* ignore */
    }
  }

  /**
   * @param {'nein' | 'ja'} initial
   */
  const mountRadios = (initial) => {
    controlInner.innerHTML = ''

    const radioGroup = document.createElement('div')
    radioGroup.className =
      'ant-radio-group ant-radio-group-outline RadioGroup justify-content-unset'
    radioGroup.setAttribute('data-testid', 'lux-nebenkosten-pauschale-radio-group')

    const groupName = `lux-nebenkosten-pauschale-${rentPlanId || 'default'}`

    const syncAntRadioClasses = () => {
      radioGroup.querySelectorAll('input.ant-radio-input').forEach((inp) => {
        const lab = inp.closest('.ant-radio-wrapper')
        const ring = lab && lab.querySelector(':scope > .ant-radio')
        const on = inp.checked
        if (lab) {
          lab.classList.toggle('ant-radio-wrapper-checked', on)
        }
        if (ring) {
          ring.classList.toggle('ant-radio-checked', on)
        }
      })
      const v = radioGroup.querySelector('input.ant-radio-input:checked')
      wrap.dataset.luxNebenkostenPauschaleValue = v ? v.value : 'nein'
    }

    /**
     * @param {'nein' | 'ja'} value
     * @param {string} text
     * @param {boolean} checked
     */
    const addOption = (value, text, checked) => {
      const opt = document.createElement('div')
      opt.className = 'radio-group-option'
      opt.setAttribute('data-testid', `radio-group-option-nebenkosten-pauschale-${value}`)

      const lab = document.createElement('label')
      lab.className =
        'ant-radio-wrapper ant-radio-wrapper-in-form-item' +
        (checked ? ' ant-radio-wrapper-checked' : '')

      const ring = document.createElement('span')
      ring.className = 'ant-radio' + (checked ? ' ant-radio-checked' : '')

      const inp = document.createElement('input')
      inp.type = 'radio'
      inp.className = 'ant-radio-input'
      inp.name = groupName
      inp.value = value
      if (checked) inp.checked = true
      if (rentPlanId) inp.dataset.rentPlanId = rentPlanId

      const inner = document.createElement('span')
      inner.className = 'ant-radio-inner'

      const textSpan = document.createElement('span')
      textSpan.textContent = text

      ring.appendChild(inp)
      ring.appendChild(inner)
      lab.appendChild(ring)
      lab.appendChild(textSpan)
      opt.appendChild(lab)
      radioGroup.appendChild(opt)
    }

    const initialNorm = initial === 'ja' ? 'ja' : 'nein'
    addOption('nein', 'Nein', initialNorm === 'nein')
    addOption('ja', 'Ja', initialNorm === 'ja')

    radioGroup.addEventListener('change', (e) => {
      if (e.target && e.target.matches && e.target.matches('input.ant-radio-input')) {
        syncAntRadioClasses()
        const checked = radioGroup.querySelector('input.ant-radio-input:checked')
        const v = checked && checked.value === 'ja' ? 'ja' : 'nein'
        persistValue(v)
      }
    })

    controlInner.appendChild(radioGroup)
    syncAntRadioClasses()
  }

  controlInput.appendChild(controlInner)

  const explain = document.createElement('div')
  explain.className = 'ant-form-item-explain ant-form-item-explain-connected'
  const alertEl = document.createElement('div')
  alertEl.setAttribute('role', 'alert')
  alertEl.className = ''
  explain.appendChild(alertEl)

  controlCol.appendChild(controlInput)
  controlCol.appendChild(explain)

  row.appendChild(labelCol)
  row.appendChild(controlCol)
  wrap.appendChild(row)

  mietartBlock.parentNode.insertBefore(wrap, mietartBlock.nextSibling)

  if (rentPlanId && token) {
    showSkeleton()
    ;(async () => {
      let initial = 'nein'
      try {
        const res = await fetch(
          `${baseApiUrl}/api/impowerX/rent-plans/${encodeURIComponent(rentPlanId)}/nebenkosten-pauschale`,
          { headers: { Authorization: `Bearer ${token}` } }
        )
        if (res.ok) {
          const data = await res.json()
          if (data && (data.value === 'ja' || data.value === 'nein')) {
            initial = data.value
          }
        }
      } catch (_e) {
        /* keep default */
      }
      mountRadios(initial)
    })()
  } else {
    mountRadios('nein')
  }
}
